import { Box, LoadingModule } from '@domain-group/suit-theme'

import type {
  UsePublicationBookingPlannerPayload,
} from '@components/PublicationBookingPlanner/hooks/usePublicationBookingPlanner'

import Canvas from './Canvas'
import Deadlines from './Deadlines'
import EditionEmpty from './EditionEmpty'
import EditionReleased from './EditionReleased'
import StageLayout from './StageLayout'
import ZoomControl from './ZoomControl'

interface StageProps {
  bookingPlannerPayload: UsePublicationBookingPlannerPayload,
}

const Stage = (props: StageProps) => {
  const {
    bookingPlannerPayload,
    bookingPlannerPayload: {
      callbacks: {
        showCreateOrEditPublicationBookingModal,
      },
      deadlineStatuses: {
        booking: {
          beforeDeadline: isBeforeBookingDeadline,
        },
      },
      editionData: {
        allPagesReleased,
      },
      publicationBookingsPayload: {
        filteredPublicationBookings,
        filteredPublicationBookingsCount,
        loading: loadingPublicationBookings,
      },
      publicationEditionPayload: {
        publicationEdition,
      },
      selectedPublicationBooking,
      zoom,
    },
  } = props

  // Loading
  if (!filteredPublicationBookingsCount && loadingPublicationBookings){
    return (
      <Box flexDirection="column" padding="large">
        <LoadingModule loading times={3} />
      </Box>
    )
  }

  // All Pages Released
  if (allPagesReleased){
    return (
      <StageLayout>
        <EditionReleased
          filteredPublicationBookings={filteredPublicationBookings}
          selectedPublicationBooking={selectedPublicationBooking}
        />
      </StageLayout>
    )
  }

  if (!filteredPublicationBookingsCount){
    return (
      <StageLayout>
        <EditionEmpty
          isBeforeBookingDeadline={isBeforeBookingDeadline}
          onClick={showCreateOrEditPublicationBookingModal}
        />
      </StageLayout>
    )
  }

  return (
    <StageLayout>
      <Canvas bookingPlannerPayload={bookingPlannerPayload} />
      <Deadlines publicationEdition={publicationEdition} />
      <ZoomControl bookingPlannerPayload={bookingPlannerPayload} />
    </StageLayout>
  )
}

export default Stage
